import {callHandlers} from '@baidu/health-tool-box-bridge';
import {isDoctorApp} from './utils';

interface LoginPageParams {
    redirectURL?: string;
    reload?: boolean;
}

export const loginPage = async ({redirectURL = '', reload = true}: Partial<LoginPageParams>) => {

    if (isDoctorApp()) {
        const result = await callHandlers?.common?.login();

        if (reload && window?.location?.reload) {
            window.location.reload();
        }

        return result;
    }

    const host = 'https://wappass.baidu.com/';

    window.location.href = `${host}?u=${encodeURIComponent(redirectURL)}`;
};
